export default __webpack_public_path__ + "static/media/gb-con.0294a4b0.svg";